import logoBettr from "../../assets/logo-bettr.png";

export const Footer = () => (
  <footer id="footer" data-testid="footer" className="bg-blackk text-ivory">
    <div className="container-bettr py-[70px] flex flex-col items-center text-center gap-8">
      <img
        src={logoBettr}
        alt="Bettr Mobility"
        className="h-11 sm:h-12 w-auto object-contain"
      />

      <a
        href="mailto:info@bettrmobility.com"
        data-testid="footer-email"
        className="font-sans text-sm sm:text-base tracking-[0.06em] text-ivory/70 hover:text-gold transition-colors duration-300"
      >
        info@bettrmobility.com
      </a>

      <div className="w-full border-t border-ivory/10 pt-7 mt-2">
        <p className="font-sans text-xs tracking-wide text-ivory/40">
          © 2026 Bettr Mobility. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
